export interface LogoutResponse {
  redirectUrl: string;
}
